import React from 'react';
import { useTranslation } from 'localization';
import ButtonAtom from '../Button/ButtonAtom';
import './LevelPillsAtom.scss';

export interface LevelPillsAtomProps {
  levels: string[];
  activeLevel: string;
  onChange: (level: string) => void;
  className?: string;
}

const LevelPillsAtom: React.FC<LevelPillsAtomProps> = ({
  levels,
  activeLevel,
  onChange,
  className = '',
}) => {
  const { t } = useTranslation();

  if (levels.length <= 1) return null;

  return (
    <div
      className={className ? `level-pills ${className}` : 'level-pills'}
      role="group"
      aria-label={t('periodSelector.level.groupLabel')}
    >
      {levels.map((level, i) => {
        const isFirst = i === 0;
        const isLast = i === levels.length - 1;
        let shape: 'square-left' | 'square-right' | 'rectangle' = 'rectangle';
        if (isFirst) shape = 'square-left';
        else if (isLast) shape = 'square-right';

        return (
          <ButtonAtom
            key={level}
            label={t(`periodSelector.level.${level}`)}
            variant={level === activeLevel ? 'primary' : 'secondary'}
            size="small"
            shape={shape}
            onClick={() => onChange(level)}
          />
        );
      })}
    </div>
  );
};

export default LevelPillsAtom;
